// GENERATED by scripts/fetch-cms.mjs — DO NOT EDIT.
// Source: Payload CMS (trainzilla-cms). Re-run `npm run cms:fetch`.

export const SITE_SETTINGS: Record<string, unknown> = {
  "siteName": "TrainZilla",
  "orgDescription": "TrainZilla is an AI-first coaching platform for personal trainers, online fitness coaches and gyms. An autonomous AI agent builds and weekly-adjusts each client's workout and diet plan under coach review, alongside client management, habit tracking, check-ins, session booking, progress tracking, payments and a branded client app.",
  "logoUrl": "https://trainzilla.app/app-icon.png",
  "ogImageDefault": "https://trainzilla.app/og-image.png",
  "social": [
    {
      "platform": "x",
      "url": "https://x.com/trainzilla_in"
    },
    {
      "platform": "facebook",
      "url": "https://www.facebook.com/people/Trainzillain/61578776257338/"
    },
    {
      "platform": "linkedin",
      "url": "https://www.linkedin.com/company/trainzilla"
    },
    {
      "platform": "instagram",
      "url": "https://www.instagram.com/trainzilla.in"
    },
    {
      "platform": "youtube",
      "url": "https://www.youtube.com/@trainzilla_in"
    },
    {
      "platform": "github",
      "url": "https://github.com/Trainzilla"
    },
    {
      "platform": "producthunt",
      "url": "https://www.producthunt.com/products/trainzilla"
    },
    {
      "platform": "playstore",
      "url": "https://play.google.com/store/apps/details?id=com.devops.tzilla.trainzillaclient"
    },
    {
      "platform": "appstore",
      "url": "https://apps.apple.com/us/app/trainzilla-for-clients/id6756607090"
    },
    {
      "platform": "capterra",
      "url": "https://www.capterra.com/p/10041943/TrainZilla/"
    },
    {
      "platform": "trustpilot",
      "url": "https://www.trustpilot.com/review/trainzilla.in"
    },
    {
      "platform": "peerpush",
      "url": "https://peerpush.com/p/trainzilla"
    },
    {
      "platform": "indiehackers",
      "url": "https://www.indiehackers.com/trainzilla"
    },
    {
      "platform": "stork",
      "url": "https://www.stork.ai/tools/trainzilla"
    }
  ],
  "contact": {
    "phone": "+91-84596-91471",
    "email": "support@trainzilla.in",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "addressCountry": "IN"
  },
  "foundingDate": "2025"
} as const
